/* Start decorative store video only while visible. Preserve a playable fallback. */
(() => {
  const videos = new Set();
  const visible = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = video => {
    if (reducedMotion.matches || navigator.connection?.saveData) {
      video.pause();
      video.controls = true;
      return;
    }
    if (document.hidden || !visible.has(video)) {
      video.pause();
      return;
    }
    video.play().catch(() => { video.controls = true; });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) visible.add(target); else visible.delete(target);
      update(target);
    });
  }, { threshold: 0.05 }) : null;
  const init = root => {
    root.querySelectorAll('video[data-jyo-autoplay="true"]').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      if (observer) observer.observe(video);
      else video.controls = true;
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    videos.forEach(video => {
      if (event.target.contains(video)) {
        observer?.unobserve(video);
        video.pause();
        videos.delete(video);
      }
    });
  });
  document.addEventListener('visibilitychange', () => videos.forEach(update));
  reducedMotion.addEventListener('change', () => videos.forEach(update));
})();
